import { render, staticRenderFns } from "./workflowLogTable.vue?vue&type=template&id=539d31e6&scoped=true"
import script from "./workflowLogTable.vue?vue&type=script&lang=js"
export * from "./workflowLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539d31e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('539d31e6')) {
      api.createRecord('539d31e6', component.options)
    } else {
      api.reload('539d31e6', component.options)
    }
    module.hot.accept("./workflowLogTable.vue?vue&type=template&id=539d31e6&scoped=true", function () {
      api.rerender('539d31e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/workflowLogTable.vue"
export default component.exports